/* eslint-disable max-len */
import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a private trip icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <PrivateTripIcon width={12} />
 */
const PrivateTripIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M25.412 14.955c-0.249 0-0.5-0.089-0.699-0.269l-9.757-8.781-9.759
            8.783c-0.429 0.385-1.091 0.351-1.476-0.079-0.387-0.428-0.352-1.091
            0.077-1.476l10.459-9.412c0.399-0.359 1.001-0.359 1.399 0l10.457
            9.412c0.429 0.387 0.464 1.048 0.077 1.476-0.208 0.229-0.493 0.347-0.779
            0.347z`}
        />
        <path
            d={`M14.955 7.635l-8.367 7.32 0.001 9.412h7.319v-1.568c0-1.44
            0.513-2.077 1.069-2.552 0.021-0.017 0.045-0.039 0.063-0.055 0.001 0
            0.001-0.001 0.001-0.001l0.015-0.048c0.389-1.188 0.753-2.283 1.028-3.083
            0.5-1.456 1.441-2.105 3.052-2.105h4.184l-8.365-7.32zM12.863
            20.184h-4.183v-4.184h4.183v4.184z`}
        />
        <path
            d={`M27.848
            21.041c-0.168-0.143-0.277-0.236-0.375-0.511-0.001-0.004-0.567-1.744-1.044-3.132-0.355-1.033-0.895-1.399-2.063-1.399h-5.229c-1.169
            0-1.708 0.365-2.063 1.399-0.477 1.388-1.043 3.128-1.044 3.132-0.097
            0.275-0.208 0.369-0.375 0.511-0.384 0.328-0.701 0.687-0.701 1.756v4.705c0
            0.575 0.471 1.045 1.045 1.045h1.047c0.575 0 1.045-0.471
            1.045-1.045v-1.045h7.32v1.045c0 0.575 0.471 1.045 1.047 1.045h1.045c0.575
            0 1.045-0.471 1.045-1.045v-4.705c0-1.069-0.317-1.428-0.701-1.756zM17.047
            24.367c-0.579 0-1.047-0.468-1.047-1.045 0-0.579 0.468-1.047 1.047-1.047
            0.577 0 1.045 0.468 1.045 1.047 0 0.577-0.468 1.045-1.045 1.045zM23.843
            25.412h-4.183c-0.288 0-0.523-0.236-0.523-0.523 0-0.288 0.236-0.523
            0.523-0.523h4.183c0.288 0 0.523 0.235 0.523 0.523 0.001 0.287-0.235
            0.523-0.523 0.523zM16.892 21.229c0 0 0.881-2.689 1.16-3.493 0.185-0.536
            0.273-0.689 1.077-0.689h5.245c0.804 0 0.892 0.155 1.079 0.689 0.279
            0.804 1.159 3.493 1.159 3.493h-9.72zM26.459 24.367c-0.579 0-1.047-0.468-1.047-1.045
            0-0.579 0.468-1.047 1.047-1.047 0.577 0 1.045 0.468 1.045 1.047 0
            0.577-0.468 1.045-1.045 1.045z`}
        />
    </SvgIcon>
)

PrivateTripIcon.defaultProps = defaultProps

export { PrivateTripIcon }
